import React from 'react';
import { connect } from 'react-redux';
import {
  columnReason,
  columnName,
  columnMultiSelect,
  columnTools,
  columnValidFrom,
  columnActive,
  columnRole,
  columnValidTo,
  columnRoleLink,
  columnCreatedBy,
  columnCreatedByLink,
  columnIpAddress,
  hasColumn,
} from '@/constants/fields';
import SortedColumn from '@/components/table/SortedColumn';
import UnsortedColumn from '@/components/table/UnsortedColumn';
import NameDescriptionColumns from '@/components/table/NameDescriptionColumns';
import { toggleTokensSelected } from '../actions';

const TokensTableColumns = ({
  category,
  items,
  onCheckBoxClick,
  columns = [
    columnMultiSelect,
    columnName,
    columnRole,
    columnIpAddress,
    columnReason,
    columnValidFrom,
    columnValidTo,
    columnActive,
    columnTools,
  ],
}) => (
  <NameDescriptionColumns
    entity="token"
    onCheckBoxClick={({ selected }) => onCheckBoxClick(category, selected)}
    items={items}
    columns={columns}
  >
    {hasColumn(columns, columnValidFrom) && (<SortedColumn name={columnValidFrom} sorted desc />)}
    {hasColumn(columns, columnValidTo) && (<UnsortedColumn columnId={columnValidTo} />)}
    {hasColumn(columns, [columnCreatedBy, columnCreatedByLink]) && (<UnsortedColumn columnId={columnCreatedBy} />)}
    {hasColumn(columns, [columnRole, columnRoleLink]) && (<UnsortedColumn columnId={columnRole} />)}
    {hasColumn(columns, [columnIpAddress, columnIpAddress]) && (<UnsortedColumn columnId={columnIpAddress} />)}
    {hasColumn(columns, columnReason) && (<UnsortedColumn columnId={columnReason} />)}
    {hasColumn(columns, columnActive) && (<UnsortedColumn columnId={columnActive} />)}
  </NameDescriptionColumns>
);

const mapDispatchToProps = {
  onCheckBoxClick: toggleTokensSelected,
};

export default connect(null, mapDispatchToProps)(TokensTableColumns);
